<app-trip-grid
  [dataSource]="tripOrdersDataSource"
  [detailComponent]="componentToRender"
  [rowClickCallback]="rowClickCallback"
>
</app-trip-grid>
